import dxFormComponent from 'devextreme-react/form';
import type { FormAction, FormItem, FormRefType } from './FormProps';
import { PageAction } from '#/app/providers/PageProvider';
import { fixDateFieldsForSubmit } from './utils/fixDateFieldsForSubmit';

const mapAction = <T,>(
  action: FormAction<T>,
  setIsLoading: (isLoading: boolean) => any,
  formRef: React.RefObject<dxFormComponent>,
  fields: FormItem<T>[],
): PageAction => {
  const btnOnClick = () => {
    if (!action.onClick) {
      return;
    }

    const form = formRef.current?.instance;
    const rawFormData = form?.option('formData') as T;
    // Fix date-only fields to prevent timezone shift when serialized to UTC
    const record = (rawFormData ? fixDateFieldsForSubmit(rawFormData, fields) : rawFormData) as T;

    action.onClick({
      form,
      record,
      setIsLoading: setIsLoading,
      clearDirty: () => (form as FormRefType | undefined)?.clearDirty?.(),
    });
  };

  if (!action.id && !action.label && !action.icon) {
    console.error(
      'Form action is missing ID, Label and Icon! At least one of them must be set!',
      action,
    );
  }

  const actionItem: PageAction = {
    id: action.id ?? action.label ?? action.icon ?? 'oops',
    alwaysShow: action.type === 'submit',
    type: 'button',
    props: {
      ...action,
      onClick: btnOnClick,
    },
  };

  return actionItem;
};

const mapPageActions = <T,>(
  actions: FormAction<T>[] | undefined,
  setIsLoading: (isLoading: boolean) => any,
  formRef: React.RefObject<dxFormComponent>,
  fields: FormItem<T>[],
): PageAction[] | undefined =>
  actions
    ?.filter((a) => a.disabled !== true)
    .map((a) => mapAction(a, setIsLoading, formRef, fields));

export default mapPageActions;
